import { render, staticRenderFns } from "./fastCheck.vue?vue&type=template&id=2b01c5fd&"
import script from "./fastCheck.vue?vue&type=script&lang=js&"
export * from "./fastCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports